export default __webpack_public_path__ + "angle-arrow-pointing-to-right.png";